import Link from "next/link"
import React from "react"
import { Image } from "react-datocms"
import ReactMarkdown from "react-markdown"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./LandingPageBody.module.scss"

const LandingPageBody = (props) => (
  <Section className={styles.LandingPageBody}>
    <SiteWrapper>
      <h2 className={styles.mainTitle}>{props.title}</h2>
      <div className={styles.tips}>
        {props.body && props.body.length
          ? props.body.map((tip) => (
              <div key={tip.id} className={styles.tip}>
                <div className={styles.content}>
                  <h3 className={styles.step}>{tip.step}</h3>
                  <h2 className={styles.title}>{tip.title}</h2>
                  <ReactMarkdown className={styles.text}>{tip.text}</ReactMarkdown>
                </div>
                <div className={styles.image}>
                  <Image data={tip.image.responsiveImage} />
                </div>
              </div>
            ))
          : null}
      </div>
    </SiteWrapper>
  </Section>
)

export default LandingPageBody
